import React from 'react';
import CompetitorScoreChart from './CompetitorScoreChart';
import KeywordPositionSection from './KeywordPositionSection';
import { useTranslation } from 'react-i18next';
import { getScoreColorClass } from 'utils/scoreColors';

const CompetitorComparisonSection = ({
  score,
  industryAverageScore,
  ranking,
  competitors,
}) => {
  const { t } = useTranslation();
  return (
    <div className="competitor-comparison-section">
      <div className="section-title">
        <div className="text">
          {t('Comparaison du score global')}
          <br />
          {t('avec le top 3 concurrents')}
        </div>
        <span className={`section-score ${getScoreColorClass(industryAverageScore)}`}>
          {industryAverageScore}%
        </span>
      </div>
      <div className="score-context">
        <p>
          {t('Vous avez un score global de')} {score}%{' '}
          {t('pour une moyenne du secteur à')} {industryAverageScore}%.
        </p>
        <p>
          {t('Vous êtes')} {ranking}{' '}
          {t('par rapport au top 3 de vos concurrents')}.
        </p>
      </div>

      <CompetitorScoreChart
        competitors={competitors}
        userLabel={t('Vous')}
        markerPosition={30}
      />
    </div>
  );
};

export default CompetitorComparisonSection;
